module.exports = __webpack_public_path__ + "static/media/strongher1_preview.0d876ed4.jpg";